module.exports = __webpack_public_path__ + "static/media/sendIcon.c58f2368.svg";